export interface OrgWideAccessSubject {
  role?: string | null;
  isOrganizationOwner?: boolean | null;
  isSuperAdmin?: boolean | null;
  isAgency?: boolean | null;
}

const ORG_WIDE_ROLES = new Set(['ADMIN']);

export function hasOrgWideBusinessAccountAccess(subject: OrgWideAccessSubject | null | undefined): boolean {
  if (!subject) return false;

  if (isTruthyFlag(subject.isSuperAdmin)) return true;
  if (isTruthyFlag(subject.isOrganizationOwner)) return true;

  const role = (subject.role ?? '').toString().trim().toUpperCase();
  if (!ORG_WIDE_ROLES.has(role)) return false;

  return !isTruthyFlag(subject.isAgency);
}

function isTruthyFlag(value: unknown): boolean {
  return value === true || value === 1 || value === '1' || value === 'true';
}

export const ORG_WIDE_ACCESS_NOTE =
  'This member has access to every business account in the organization, so it cannot be narrowed here. Change their role to User or Agent to limit which accounts they can access.';

export function resolveSelectedBusinessAccountIds(
  args: {
    subject: OrgWideAccessSubject;
    allAccountIds: readonly string[];
    storedSelection: readonly string[];
  },
): string[] {
  const { subject, allAccountIds, storedSelection } = args;
  if (hasOrgWideBusinessAccountAccess(subject)) return [...(allAccountIds ?? [])];
  return [...(storedSelection ?? [])];
}
